import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Card, Tab } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import localize from "../../../common/localize";
import EventInfo from "./EventInfoTable";
import TimeDistributionCard from "./TimeDistributionCard";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const DonutChart = ({ chartTitle, chartSubtitle, chartData, showAsTabs }) => {
  const [selectedTab, setSelectedTab] = useState("0");

  const { data, options } = useMemo(() => {
    const values = chartData?.data?.map((x) => x.value) || [100];
    const labels = chartData?.data
      ? chartData.data.map((x) => `${x.label} (${x.value.toFixed(4)}%)`)
      : [localize.total];
    const colors = chartData?.data?.map((x) => x.backColor) || ["#ccc"];

    return {
      data: {
        labels,
        datasets: [
          {
            data: values,
            backgroundColor: colors,
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: !!chartTitle,
            text: chartTitle || "",
          },
          subtitle: {
            display: !!chartSubtitle,
            text: chartSubtitle || "",
          },
          legend: {
            display: true,
            position: "bottom",
            labels: { boxWidth: 12, padding: 10 },
          },
        },
      },
    };
  }, [chartData, chartTitle, chartSubtitle]);

  const handleTabChange = (e, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <div className="w-full lateral padding">
      {showAsTabs ? (
        <TabContext value={selectedTab} className="lateral_padding">
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleTabChange}>
              <Tab label={localize.graph} value="0" />
              <Tab label={localize.execution_times} value="1" />
            </TabList>
          </Box>

          <TabPanel value="0">
            <div style={{ position: "relative", width: 600, height: 400 }}>
              <Doughnut data={data} options={options} />
            </div>
          </TabPanel>

          <TabPanel value="1">
            <div
              className="w-full"
              style={{
                width: "600px",
                overflowY: "auto",
                maxHeight: "800px",
              }}
            >
              <TimeDistributionCard data={chartData} />
            </div>
          </TabPanel>
        </TabContext>
      ) : (
        <Box className="flex flex-col gap-4 w-full">
          <Card
            variant="outlined"
            className="flex items-center justify-center p-2"
          >
            <div style={{ position: "relative", width: 500, height: 400 }}>
              <Doughnut data={data} options={options} />
            </div>
          </Card>

          <Card variant="outlined">
            <TimeDistributionCard data={chartData} />
          </Card>
        </Box>
      )}
    </div>
  );
};

export default DonutChart;
